import { Component, OnInit, forwardRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import moment from 'moment';

import { DemoozModalComponent, DemoozCardComponent, DemoozInputComponent, DemoozMessageComponent } from '@demooz/components';
import { FaqDetailsComponent } from '@app/components';
import { DataService, ValidatorsService } from '@app/services';
import { OperationFaq } from '@app/models';

@Component({
    selector: 'app-faq-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    imports: [
        IonIcon, TranslatePipe, ReactiveFormsModule,
        forwardRef(() => DemoozModalComponent), forwardRef(() => DemoozCardComponent), forwardRef(() => DemoozInputComponent), 
        forwardRef(() => DemoozMessageComponent), forwardRef(() => FaqDetailsComponent)
    ]
})
export class FaqListComponent implements OnInit {
      
    @ViewChild('modalFaq') modalFaq: DemoozModalComponent;
      
    faq: Array<OperationFaq> = [];
    faqToDisplay: Array<OperationFaq> = [];
    faqSelected: OperationFaq|null = null;
    maxItemsFaq: number = 4;
    showAllFaq: boolean = false;
    
    searchForm: FormGroup = new FormGroup({
        search: new FormControl(null)
    });
    searchUpdateSubscription: Subscription;
      
    constructor(             
        public translateService: TranslateService,
        public dataService: DataService
    ) { }

    ngOnInit() {
        this.faq = this.dataService.operation.faq;
        this.searchFaq();
    
        this.searchUpdateSubscription = this.searchForm.controls['search'].valueChanges.subscribe(value => {
            this.searchFaq();
        });
    }
    
    ngOnDestroy() {  
        if(this.searchUpdateSubscription){
            this.searchUpdateSubscription.unsubscribe();
        }
    }
    
    searchFaq(){
        let faqToDisplay: Array<OperationFaq> = this.faq.slice();
        let search = ValidatorsService.CleanString(this.searchForm.controls['search'].value);
        if(search && search !== ''){
            let regexSearch = new RegExp(search, 'gi');
            faqToDisplay = faqToDisplay.filter((f) => {
                return f.titleCleaned?.match(regexSearch)
                    || f.subtitleCleaned?.match(regexSearch)
                    || f.descriptionCleaned?.match(regexSearch);
            });
        }
        this.showAllFaq = false;
        this.faqToDisplay = faqToDisplay;
    }
    
    displayAllFaq(){
        this.showAllFaq = true;
    }
    
    openModalFaq(faq: OperationFaq){
        this.faqSelected = faq;
        this.modalFaq.open();
    }
    
    onDidDismissModalFaq(event: any){
        this.faqSelected = null;
    }
}
